import React from "react";
// Customizable Area Start
import scale, { verticalScale } from "../../../components/src/Scale";
import {
  KeyboardAvoidingView,
  ScrollView,
  StatusBar,
  View,
  Text,
  SafeAreaView,
  StyleSheet,
  Image,
  ImageSourcePropType
} from "react-native";

import PostCreationController, {Props, configJSON} from "./PostCreationController.web";
// Customizable Area End
export default class PostDetails extends PostCreationController {
  constructor(props: Props) {
    super(props);
  }

// Customizable Area Start
// Customizable Area End

  render() {
    // Customizable Area Start
    return (
      <SafeAreaView style={styles.container}>
        <StatusBar barStyle="light-content" />
        <ScrollView
          keyboardShouldPersistTaps="handled"
          contentContainerStyle={styles.containerBoxStyle}
        >
          <KeyboardAvoidingView enabled style={styles.container}>
            <View style={styles.bodyContent} />
            <Text style={styles.textDescriptionTitle}>{configJSON.PostName}:</Text>
            <Text style={styles.textDescriptionTitle}>{configJSON.Cost}:</Text>
            <Text style={styles.textDescriptionTitle}>{configJSON.Description}:</Text>
            <Text style={styles.textDescriptionTitle}>{configJSON.PostID}:</Text>
          </KeyboardAvoidingView>
        </ScrollView>
      </SafeAreaView>
    );
    // Customizable Area End
  }
}

// Customizable Area Start
const styles = StyleSheet.create({
  container: {
    flex: 1
  },

  bodyContent: {
    marginStart: scale(10),
    marginEnd: scale(10)
  },

  textStyleTitle: {
    fontSize: scale(18.7),
    marginStart: scale(17.7),
    marginTop: verticalScale(12.7)
  },

  textStylePrice: {
    fontSize: scale(18.2),
    marginStart: scale(17.7),
    marginTop: verticalScale(8.7)
  },

  row: {
    flexDirection: "row",
    height: scale(37.7),
    alignItems: "center",
    marginTop: verticalScale(14),
    paddingStart: scale(17.7)
  },

  viewEditDelete: {
    alignItems: "center",
    alignSelf: "center",
    top: 0,
    right: 0,
    position: "absolute",
    justifyContent: "flex-end",
    marginEnd: scale(17)
  },

  textActive: {
    alignSelf: "flex-start",
    paddingStart: scale(15),
    paddingEnd: scale(15),
    paddingTop: verticalScale(2),
    paddingBottom: verticalScale(2),
    borderRadius: 10,
    fontSize: scale(10.7),
    marginStart: scale(7),
    marginEnd: scale(7)
  },

  textPublish: {
    fontSize: scale(14.2)
  },

  textDescriptionTitle: {
    fontSize: scale(20),
    marginStart: scale(17.7),
    marginTop: verticalScale(5),
    fontWeight: "bold"
  },

  textDescription: {
    fontSize: scale(16),
    marginStart: scale(16.7),
    marginTop: verticalScale(8),
    textAlign: "left"
  },

  textPostId: {
    fontSize: scale(16.2),
    marginLeft: scale(16.7),
    marginVertical: verticalScale(5)
  },

  ButtonConatiner: {
    position: "absolute",
    bottom: verticalScale(14.3),
    left: 0,
    right: 0,
    shadowColor: "#000",
    shadowOpacity: 0.02,
    height: scale(72),
    width: scale(414),
    alignContent: "center"
  },

  InnerConatiner: {
    justifyContent: "space-between",
    flexDirection: "row",
    marginTop: verticalScale(14.3),
    marginHorizontal: scale(16.3)
  },

  customTxtStyle: {
    alignSelf: "center",
    fontSize: scale(16.5)
  },

  customTxtStyleClose: {
    alignSelf: "center",
    fontSize: scale(16.5)
  },

  buttonCustom: {
    width: scale(182.3),
    height: scale(43.3),
    borderRadius: 22.1,
    alignItems: "center",
    justifyContent: "center"
  },

  buttonCustomClose: {
    width: scale(182.3),
    height: scale(43.3),
    borderRadius: 22.1,
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center"
  },

  userConatiner: {
    height: verticalScale(66),
    borderTopWidth: 0.5,
    borderBottomWidth: 0.5,
    marginTop: verticalScale(13)
  },

  userProfileName: {
    flexDirection: "row",
    marginTop: verticalScale(14),
    alignItems: "center"
  },

  userImagesIcon: {
    width: scale(37.7),
    height: scale(38),
    borderRadius: scale(18.7)
  },

  userIcon: {
    width: scale(20),
    height: scale(24),
    alignSelf: "center",
    marginTop: verticalScale(7)
  },

  userName: {
    fontSize: scale(14.2),
    textAlign: "left"
  },

  userMemberShip: {
    fontSize: scale(10.7),
    textAlign: "left"
  },

  offerPrice: {
    marginBottom: verticalScale(12),
    marginTop: verticalScale(28),
    fontSize: scale(16.7)
  },

  buttonCustomSend: {
    width: scale(185.7),
    height: scale(43.3),
    borderRadius: 22.1,
    alignItems: "center",
    alignSelf: "center",
    justifyContent: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 1
    },
    shadowOpacity: 0.18,
    shadowRadius: 1.0,
    elevation: 1
  },

  containerBoxStyle: {
    flexGrow: 1,
    justifyContent: "center",
    paddingBottom: verticalScale(10)
  }
});
// Customizable Area End
